import { useNavigate } from "react-router-dom";
import { Play, ArrowUpRight } from "lucide-react";
import { Reveal, Magnetic } from "../lib/motion";

export default function SchedulingTeaser() {
  const navigate = useNavigate();

  return (
    <section
      id="scheduling"
      className="relative border-t border-white/5 bg-nexis-bg/80 py-28 backdrop-blur-sm md:py-40"
      data-testid="scheduling-teaser-section"
    >
      <div className="orb orb-blue left-[8%] top-[20%] h-[340px] w-[340px]" />
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal>
            <span className="font-mono text-xs tracking-[0.25em] text-nexis-blue">— PRECISION OPERATIONS</span>
            <h2 className="mt-5 font-display text-4xl font-light tracking-tight lg:text-5xl">
              Master Scheduling &<br />
              <span className="text-gradient">Spatial Engineering</span>.
            </h2>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-white/55">
              We don't just coordinate timelines — we structurally engineer them. NASA-grade mission
              planning, dependency mapping, and AI-driven digital twins that simulate every guest
              pathway and vendor asset before operations go live.
            </p>
            <div className="mt-9">
              <Magnetic>
                <button
                  onClick={() => navigate("/scheduling")}
                  className="group flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-medium text-black transition-transform hover:scale-[1.02]"
                  data-testid="scheduling-teaser-cta"
                >
                  Explore the full capability
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </Magnetic>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <button
              onClick={() => navigate("/scheduling")}
              className="group relative block w-full overflow-hidden rounded-[2rem] glass"
              data-testid="scheduling-teaser-video"
            >
              <div className="relative aspect-video w-full overflow-hidden rounded-[2rem]">
                <img
                  src="/scheduling-poster.jpg"
                  alt="AI spatial layout pre-simulation"
                  className="h-full w-full object-cover opacity-75 transition-all duration-700 group-hover:scale-105 group-hover:opacity-95"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-nexis-bg/80 via-nexis-bg/20 to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-nexis-blue/90 text-black shadow-[0_0_40px_rgba(0,200,255,0.5)] transition-transform group-hover:scale-110">
                    <span className="absolute inset-0 rounded-full bg-nexis-blue/40 blur-md" />
                    <Play className="relative ml-0.5 h-6 w-6 fill-black" />
                  </span>
                </div>
                <div className="absolute bottom-5 left-5 font-mono text-[10px] tracking-widest text-white/60">
                  AI SPATIAL LAYOUT PRE-SIMULATION
                </div>
              </div>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
